import React, { Component } from 'react';
import { string, bool, arrayOf, object, number } from 'prop-types';
import compose from 'lodash/flowRight';
import { promotedFiltersShape } from 'shapes';
import {
    withPromotedFilters,
    withFeatureFlags,
    connectCurrentRefinements,
} from 'connectors';
import { isCurrentRefinementItemsChanged } from './utils';
import PromotedFilters from '../PromotedFilters/PromotedFilters';

export class PromotedFiltersWrapper extends Component {
    static propTypes = {
        className: string,
        guidedNavigationEnabled: bool.isRequired,
        promotedFiltersEnabled: bool.isRequired,
        promotedFilters: arrayOf(promotedFiltersShape).isRequired,
        items: arrayOf(object).isRequired,
        categoryId: number,
    };

    static defaultProps = {
        className: null,
        categoryId: null,
    };

    static getDerivedStateFromError(error) {
        return { hasError: true, error };
    }

    state = {};

    shouldComponentUpdate(nextProps) {
        const {
            items,
            promotedFilters,
            guidedNavigationEnabled,
            promotedFiltersEnabled,
            className,
        } = this.props;

        return (
            isCurrentRefinementItemsChanged(items, nextProps.items) ||
            promotedFilters !== nextProps.promotedFilters ||
            guidedNavigationEnabled !== nextProps.guidedNavigationEnabled ||
            promotedFiltersEnabled !== nextProps.promotedFiltersEnabled ||
            className !== nextProps.className
        );
    }

    render() {
        if (this.state.hasError) {
            console.warn(
                `PromotedFilters in category "${this.props.categoryId}" is broken.`,
                this.state.error,
            );
            return null;
        }

        const {
            promotedFilters,
            className,
            guidedNavigationEnabled,
            promotedFiltersEnabled,
            items,
        } = this.props;

        const shouldShowPromotedFilters =
            guidedNavigationEnabled &&
            promotedFiltersEnabled &&
            promotedFilters.length > 0;

        return (
            shouldShowPromotedFilters && (
                <PromotedFilters
                    className={className}
                    promotedFilters={promotedFilters}
                    currentRefinements={items}
                />
            )
        );
    }
}

export default compose(
    withFeatureFlags({
        guidedNavigationEnabled: 'browsing.guided.navigation',
        promotedFiltersEnabled: 'browsing.guided.navigation.promotedfilters',
    }),
    withPromotedFilters,
    connectCurrentRefinements,
)(PromotedFiltersWrapper);
